import { render, staticRenderFns } from "./ModalAddArticle.vue?vue&type=template&id=8f8d0bf8&"
import script from "./ModalAddArticle.vue?vue&type=script&lang=js&"
export * from "./ModalAddArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports